import { render, staticRenderFns } from "./MakeLinkAside.vue?vue&type=template&id=45b0d619&scoped=true"
import script from "./MakeLinkAside.vue?vue&type=script&lang=js"
export * from "./MakeLinkAside.vue?vue&type=script&lang=js"
import style0 from "./MakeLinkAside.vue?vue&type=style&index=0&id=45b0d619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0d619",
  null
  
)

export default component.exports